module.exports = __webpack_public_path__ + "static/media/christmas-tree-removal.c608b180.svg";